import * as React from 'react';
import { useContext, useState } from 'react';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import type { InlineFeedbackRubricContextType } from 'bundles/grading/components/staff-graded-assignments/form-parts/InlineFeedbackRubricContext';
import { InlineFeedbackRubricContext } from 'bundles/grading/components/staff-graded-assignments/form-parts/InlineFeedbackRubricContext';
import { isGradeHiddenInGradebookEntry } from 'bundles/grading/utils/gradeUtils';

type Props = {
  children: React.ReactNode;
};

export const InlineFeedbackRubricProvider = ({ children }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { submissionData } = useContext(SGAPageContext);
  const { gradebookEntry } = submissionData.data || {};

  const contextValue: InlineFeedbackRubricContextType = {
    isExpanded,
    setIsExpanded,
    // read-only state is currently determined by the submitter's grade visibility
    isReadOnly: !isGradeHiddenInGradebookEntry(gradebookEntry || null),
  };

  return <InlineFeedbackRubricContext.Provider value={contextValue}>{children}</InlineFeedbackRubricContext.Provider>;
};

export default InlineFeedbackRubricProvider;
